import Attention from "./Attention";
import GateStrip from "./GateStrip";
import { fillVoice } from "../lib/master";

/** Role header — queue only when explicitly enabled (analytics drill-down). */
export default function RoleHomeShell({
  guide,
  portfolio,
  app,
  appId,
  count,
  primaryAction,
  showQueue = false,
  compact = false,
  children,
}) {
  const headline = fillVoice(guide?.headline, count) || "Governed workspace";
  const lede = compact ? null : fillVoice(guide?.lede, count);
  const kicker = guide?.kicker || "ROLE HOME";

  return (
    <section className={`role-home${compact ? " role-home-compact" : ""}`} data-testid="role-home">
      <div className="role-home-head">
        <p className="kicker">{kicker}</p>
        <h1 data-testid="role-home-headline">{headline}</h1>
        {lede && <p className="intro-copy">{lede}</p>}
        {!compact && guide?.pointer && <p className="role-home-pointer" data-testid="role-home-pointer">{guide.pointer}</p>}
      </div>

      {showQueue && portfolio && (
        <Attention
          items={portfolio.attention}
          approvals={portfolio.approvals}
          actions={portfolio.actions}
          waiting={portfolio.waiting}
          appId={appId || app?.id}
          guide={guide}
        />
      )}

      {primaryAction}

      {app?.gates?.length > 0 && <GateStrip gates={app.gates} guide={guide} compact />}

      {children}
    </section>
  );
}
